import React, { useState } from 'react'
import '../assets/css/contact.css'
import Header from '../components/Header';
import Footer from '../components/Footer';

function Contact() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Submitted:', formData);
        alert('Thank you for your message! We will contact you shortly.');
    };

    return (
        <>
            {/* ---------------- HEADER ---------------- */}
            

            {/* ---------------- Contact SECTION ---------------- */}
            <main className="contact-section-wrapper">
                <section id="contact" className="contact-container">
                    <div className="contact-card">
                        <div className="contact-grid">

                            {/* Left Column: Contact Info & Map */}
                            <div className="info-column">
                                <h2 className="section-heading">Contact & Visit</h2>
                                <p className="section-subtext">Drop by or call us for urgent queries.</p>

                                <div className="info-list">
                                    <div>
                                        <strong>Address:</strong> B-123, Main Market, New Delhi, India
                                    </div>
                                    <div>
                                        <strong>Phone:</strong> <a href="tel:+919999999999" className="info-link">+91 99999 99999</a>
                                    </div>
                                    <div>
                                        <strong>Email:</strong> <a href="mailto:info@mvlpharmacy.com" className="info-link">info@mvlpharmacy.com</a>
                                    </div>
                                    <div>
                                        <strong>Hours:</strong> Mon–Sun: 8:00 AM — 9:00 PM
                                    </div>
                                </div>

                                <div className="map-section">
                                    <h3 className="map-title">Find us on the map</h3>
                                    <div className="map-placeholder">
                                        Map Placeholder
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: Contact Form */}
                            <div className="form-column">
                                <h3 className="form-heading">Send us a message</h3>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="name" className="sr-only">Name</label>
                                        <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            placeholder="Your name"
                                            className="form-input"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email" className="sr-only">Email</label>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            placeholder="you@example.com"
                                            className="form-input"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="message" className="sr-only">Message</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            rows="5"
                                            placeholder="How can we help?"
                                            className="form-textarea"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="form-actions">
                                        <button type="submit" className="btn-submit">
                                            Send message
                                        </button>
                                        <a href="tel:+919999999999" className="link-call">
                                            Or call us
                                        </a>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </section>
            </main>

           
        </>
    )
}

export default Contact